import type { BoxProps } from "@mui/material";
import { Box } from "@mui/material";
import React from "react";

import fullDark from "assets/logo/full_dark.png";
import hFullWhite from "assets/logo/h_full_white.png";
import mini from "assets/logo/mini.png";

type Variant = "fullDark" | "hFullWhite" | "mini";

export interface LogoProps extends BoxProps {
  imgHeight?: number;
  imgWidth?: number;
  variant?: Variant;
  objectFit?: "fill" | "contain" | "cover" | "none" | "scale-down";
  objectPosition?: string;
}

const icons = { fullDark, hFullWhite, mini };

const Logo: React.FC<React.PropsWithChildren<LogoProps>> = ({
  sx,
  variant,
  imgHeight,
  imgWidth,
  objectFit,
  objectPosition,
}) => (
  <Box sx={sx}>
    <img
      src={icons[variant as Variant]}
      alt="Flows"
      style={{ width: imgWidth || 40, height: imgHeight || 40, objectFit, objectPosition }}
    />
  </Box>
);

Logo.defaultProps = { variant: "fullDark" };

export default Logo;
